"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VirtualNetProcessor = exports.NO_CONNECT_VIRTUAL_NET_METADATA_VALUE = exports.VIRTUAL_NET_METADATA_KEY = void 0;
const BoundaryLevel_1 = require("../../BoundaryLevel");
exports.VIRTUAL_NET_METADATA_KEY = 'virtual';
exports.NO_CONNECT_VIRTUAL_NET_METADATA_VALUE = 'noconnect';
class VirtualNetProcessor {
    static assignVirtualNetsToNoConnectPins(project) {
        for (const design of Object.values(project.designs)) {
            VirtualNetProcessor.assignVirtualNetsForDesign(project, design);
        }
    }
    static assignVirtualNetsForDesign(project, design) {
        const existingNetNames = new Set([...Object.keys(design.nets), ...Object.keys(project.globalNets ?? {})]);
        for (const module of design.modules) {
            VirtualNetProcessor.assignVirtualNetsForModule(project, design, module, existingNetNames);
        }
    }
    static assignVirtualNetsForModule(project, design, module, existingNetNames) {
        const component = project.components[module.componentRef];
        if (!component) {
            project.processingResults.innerResults.push({
                type: 'virtual-net-processor-missing-module',
                message: `VirtualNetProcessor: module "${module.name}" (${module.ref}) references unknown component "${module.componentRef}"; skipping no-connect pin processing`,
                severity: BoundaryLevel_1.BoundaryLevel.Error,
            });
            return;
        }
        if (component.isVirtual) {
            return;
        }
        const pins = VirtualNetProcessor.getPinsForModule(component, module, design);
        if (pins.length === 0) {
            return;
        }
        const processedPinRefs = new Set();
        for (const pin of pins) {
            if (processedPinRefs.has(pin.ref)) {
                continue;
            }
            processedPinRefs.add(pin.ref);
            const existing = module.pinNets[pin.ref];
            if (typeof existing === 'string' && existing.length > 0) {
                continue;
            }
            const signal = VirtualNetProcessor.findSignalForPin(component, pin.ref);
            const virtualNetName = VirtualNetProcessor.makeUniqueVirtualNetName(module, pin, signal, existingNetNames);
            module.pinNets[pin.ref] = virtualNetName;
            const netInfo = {
                name: virtualNetName,
                connections: [
                    {
                        moduleRef: module.ref,
                        moduleName: module.name,
                        pinRef: pin.ref,
                    },
                ],
                metadata: { [exports.VIRTUAL_NET_METADATA_KEY]: exports.NO_CONNECT_VIRTUAL_NET_METADATA_VALUE },
                netLabels: [],
            };
            design.nets[virtualNetName] = netInfo;
        }
    }
    static getPinsForModule(component, module, design) {
        if (design.modelType === 'schematic') {
            const symbol = component.symbols.find((s) => s.ref === module.footprintRef);
            if (!symbol) {
                return [];
            }
            return symbol.pins.map((p) => ({ ref: p.ref, name: p.name, number: p.number }));
        }
        const footprint = component.footprints.find((f) => f.ref === module.footprintRef);
        if (!footprint) {
            return [];
        }
        return footprint.pads.map((p) => ({ ref: p.ref, name: p.name }));
    }
    static findSignalForPin(component, pinRef) {
        return component.signals.find((s) => s.pinRefs.some((ref) => ref === pinRef));
    }
    static makeUniqueVirtualNetName(module, pin, signal, existingNetNames) {
        const identifier = pin.number && pin.number.length > 0 ? pin.number : pin.ref;
        const descriptor = pin.name.length > 0 ? pin.name : (signal?.name ?? '');
        const rawSegments = [module.name, identifier, descriptor].filter((s) => s.length > 0);
        const base = VirtualNetProcessor.sanitizeNetName(rawSegments.join('_'));
        const safeBase = base.length > 0 ? base : VirtualNetProcessor.sanitizeNetName(`${module.name}_${pin.ref}`);
        const finalBase = safeBase.length > 0 ? safeBase : 'virtual_net';
        let candidate = finalBase;
        let suffix = 1;
        while (existingNetNames.has(candidate)) {
            candidate = `${finalBase}_${suffix}`;
            suffix++;
        }
        existingNetNames.add(candidate);
        return candidate;
    }
    static sanitizeNetName(name) {
        return name
            .replace(/[^a-zA-Z0-9_\-.()]/g, '_')
            .replace(/_+/g, '_')
            .replace(/^_+|_+$/g, '');
    }
}
exports.VirtualNetProcessor = VirtualNetProcessor;
//# sourceMappingURL=VirtualNetProcessor.js.map